import { lastValueFrom } from 'rxjs';
// import { Component } from '@angular/core};
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  Type,
  ViewChild,
} from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject } from 'rxjs';
import { AppCommon } from '../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../models-views/sourcing-needs-v2.view.model';
import { SourcingNeedModel } from '../../../models/sourcing-need.model';
import { StandardResponseModel } from '../../../models/event.model';
import { OutsourcingTypeModel } from '../../../models/outsourcing.model';
import LoginModel from '../../../models/user.model';
import { SnFormVenueV2Component } from './modals/sn-form-venue-v2/sn-form-venue-v2.component';
import { SnFormCateringV2Component } from './modals/sn-form-catering-v2/sn-form-catering-v2.component';
import { SnFormPhotoVideoV2Component } from './modals/sn-form-photo-video-v2/sn-form-photo-video-v2.component';
import { SnFormBrandingV2Component } from './modals/sn-form-branding-v2/sn-form-branding-v2.component';
import { SnFormGiftV2Component } from './modals/sn-form-gift-v2/sn-form-gift-v2.component';
import { SnFormTransportV2Component } from './modals/sn-form-transport-v2/sn-form-transport-v2.component';
import { SnFormSpeakerTalentV2Component } from './modals/sn-form-speaker-talent-v2/sn-form-speaker-talent-v2.component';
import { SnFormFurnitureV2Component } from './modals/sn-form-furniture-v2/sn-form-furniture-v2.component';
import { SnFormAvV2Component } from './modals/sn-form-av-v2/sn-form-av-v2.component';
import { SnFormExperienceV2Component } from './modals/sn-form-experience-v2/sn-form-experience-v2.component';
import { SnFormProductionFabricationV2Component } from './modals/sn-form-production-fabrication-v2/sn-form-production-fabrication-v2.component';

interface RequiredItem {
  key: string;
  data_key: string;
  name: string;
  value: boolean;
  data: any;
  nzTitle: string;
  nzContent: Type<any>;
  isLoading?: boolean;
  colSpan?: number;
}

@Component({
  selector: 'app-cet-sourcing-needs-v2',
  templateUrl: './cet-sourcing-needs-v2.component.html',
  styleUrls: ['./cet-sourcing-needs-v2.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CetSourcingNeedsV2Component implements OnInit, OnChanges {
  
  @Input() eventId: number | null = null;
    // private _souringNeedId: number | null = null;
    // @Input()
    // set souringNeedId(val: number | null) {
    //   // console.log('=====================================================', val);
    //   this._souringNeedId = val;
    // }
    // get souringNeedId(): number | null {
    //   return this._souringNeedId;
    // }

    @Input() allEventData: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['souringNeedId']) {
    }
    if (changes['eventId']) {
    }
    if (changes['allEventData']) {
      console.log('Received new allEventData in ngOnChanges:', this.allEventData);
      // ---this below id is event id just naming is wrong ---//
      // this.souringNeedId = this.allEventData?.id;
      const nextSourcingNeedId = this.allEventData?.sourcing_need ?? null;
      const hasSourcingNeedChanged = this.souringNeedId !== nextSourcingNeedId;

      this.souringNeedId = nextSourcingNeedId;

      if (hasSourcingNeedChanged) {
        this.resetSourcingNeedLocalState();
        if (this.souringNeedId) {
          this.vm.getSouringNeedbyId(this.souringNeedId, 'cet-sourcing-needs-v2');
        }
      }
    }
  }

  @ViewChild(SnFormAvV2Component) avFormComponent?: SnFormAvV2Component;
  @ViewChild(SnFormVenueV2Component)
  venueFormComponent?: SnFormVenueV2Component;
  @ViewChild(SnFormCateringV2Component)
  cateringFormComponent?: SnFormCateringV2Component;
  @ViewChild(SnFormPhotoVideoV2Component)
  photoVideoFormComponent?: SnFormPhotoVideoV2Component;
  @ViewChild(SnFormBrandingV2Component)
  brandingFormComponent?: SnFormBrandingV2Component;
  @ViewChild(SnFormGiftV2Component) giftFormComponent?: SnFormGiftV2Component;
  @ViewChild(SnFormTransportV2Component)
  transportFormComponent?: SnFormTransportV2Component;
  @ViewChild(SnFormSpeakerTalentV2Component)
  speakerFormComponent?: SnFormSpeakerTalentV2Component;
  @ViewChild(SnFormFurnitureV2Component)
  furnitureFormComponent?: SnFormFurnitureV2Component;
  @ViewChild(SnFormExperienceV2Component)
  experienceFormComponent?: SnFormExperienceV2Component;
  @ViewChild(SnFormProductionFabricationV2Component)
  productionFabricationFormComponent?: SnFormProductionFabricationV2Component;

  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  sourcingNeedModel!: BehaviorSubject<SourcingNeedModel>;
  sourcingEventTypeModel = new BehaviorSubject<StandardResponseModel>(
    new StandardResponseModel()
  );
  // outsourcingTypesList: OutsourcingTypeModel[] = [];
  outsourcingTypesList: any[] = [];

  sourcingNeedData: any = null;

  isSourcingNeedAvailable: boolean = false;
  selectedEventType: number | null = null;
  isEditingEventType: boolean = false;
  showEditEventTypeButton: boolean = true;
  souringNeedId: number | null = null;
  // Individual data properties for each child component
  venueData: any = null;
  cateringData: any = null;
  transportData: any = null;
  photoVideoData: any = null;
  brandingData: any = null;
  giftData: any = null;
  speakerData: any = null;
  furnitureData: any = null;
  experienceData: any = null;
  avData: any = null;
  productionFabricationData: any = null;

  // Menu items for the left panel (will be populated from API)
  menuItems: Array<{ key: string; name: string; emoji: string; image?: string }> = [];

  // UI state for view/edit mode, context-sensitive to active tab
  isView: boolean = false;
  isEdit: boolean = false;
  isModalVisible: boolean = false;
  modalTitle: string = '';

  // Tracks whether the modal was opened over pre-existing data (edit) vs fresh add
  private modalOpenedWithExistingData: boolean = false;

  // Call this after any tab switch or data change
  updateViewEditState(): void {
    const hasData = this.hasMeaningfulData(this.getDataForActiveTab());
    const isRequired = this.getRequirementValueForActiveTab();

    this.isView = hasData && isRequired;
  }

  private hasMeaningfulData(data: any): boolean {
    if (data === null || data === undefined) {
      return false;
    }

    if (Array.isArray(data)) {
      return data.length > 0;
    }

    if (typeof data === 'string') {
      return data.trim().length > 0 && data.trim() !== '-';
    }

    if (typeof data === 'number') {
      return !Number.isNaN(data);
    }

    if (typeof data === 'boolean') {
      return data;
    }

    if (typeof data === 'object') {
      return Object.values(data).some((value) => this.hasMeaningfulData(value));
    }

    return false;
  }

  // Helper method to get data for the currently active tab
  public getDataForActiveTab(): any {
    let data: any = null;
    switch (this.activeTab) {
      case 'av': data = this.avData; break;
      case 'venue': data = this.venueData; break;
      case 'catering': data = this.cateringData; break;
      case 'photographer': data = this.photoVideoData; break;
      case 'branding': data = this.brandingData; break;
      case 'gift': data = this.giftData; break;
      case 'transport': data = this.transportData; break;
      case 'speaker': data = this.speakerData; break;
      case 'furniture': data = this.furnitureData; break;
      case 'experience': data = this.experienceData; break;
      case 'productionFabrication': data = this.productionFabricationData; break;
      default: data = null;
    }
    return data;
  }

  onEdit(): void {
    this.modalOpenedWithExistingData = true;
    this.openModal();
  }

  onCancel(): void {
    this.closeModal('cancel');
  }

  openModal(): void {
    this.isModalVisible = true;
    this.modalTitle = this.getActiveTabName();
  }

  // Handle modal X button click
  onModalXClick(): void {
    this.closeModal('cancel');
  }

  // Updated to handle closeModal event with reason
  closeModal(reason?: 'success' | 'cancel'): void {
    this.isModalVisible = false;

    if (reason === 'cancel') {
      if (!this.modalOpenedWithExistingData) {
        // User toggled Yes then cancelled without saving — revert local state
        // and clean up the is_required flag + OutsourcingEventRequest on the backend
        const key = this.getRequirementKeyForActiveTab();
        const config = this.isRequiredModels.find((item) => item.key === key);
        if (config) config.value = false;
        this.revertRequirementFlag(key);
      }
      // If editing existing data: keep everything as-is, no API call needed
    }
    // On success the form component already called getSouringNeedbyId which will update state

    this.modalOpenedWithExistingData = false;
    this.updateViewEditState();
  }
  // Handler for child modal close event
  onModalClosed(reason?: 'success' | 'cancel'): void {
    this.closeModal(reason);
  }

  onRequirementChange(required: boolean): void {
    const key = this.getRequirementKeyForActiveTab();
    const config = this.isRequiredModels.find((item) => item.key === key);
    if (!config) return;

    if (required) {
      const hasData = this.hasMeaningfulData(this.getDataForActiveTab());
      config.value = true;
      this.modalOpenedWithExistingData = hasData;

      if (!hasData) {
        // New add: fire API to set flag + register OutsourcingEventRequest, then open modal
        this.updateRequirementFlag(key, true);
        this.isView = false;
        this.openModal();
      } else {
        // Already has data — just toggle the flag (re-enabling after a No)
        this.updateRequirementFlag(key, true);
        this.updateViewEditState();
      }
    } else {
      config.value = false;
      this.isView = false;
      // Properly clean up: delete sub-record if exists, else clear flag + OutsourcingEventRequest
      this.deleteOrClearActiveTab();
    }
  }

  private updateRequirementFlag(key: string, value: boolean): void {
    if (!key || !this.souringNeedId) return;

    const payload: any = {
      id: this.souringNeedId,
      modified_by: this.loginModel.value.user.id,
      [key]: value,
    };

    // omitRemove=true → backend receives no 'remove' key → creates OutsourcingEventRequest
    if (value) {
      payload.omitRemove = true;
    } else {
      payload.remove = false;
    }

    this.vm.updateSourcingNeed(payload, 'cet-sourcing-needs-v2');
  }

  /**
   * Reverts a requirement flag to false and sends remove:true so the backend
   * also deletes the associated OutsourcingEventRequest (when no QuotationRequest
   * is linked). Used when user cancels a brand-new Yes → modal flow.
   */
  private revertRequirementFlag(key: string): void {
    if (!key || !this.souringNeedId) return;

    this.vm.updateSourcingNeed({
      id: this.souringNeedId,
      modified_by: this.loginModel.value.user.id,
      [key]: false,
      remove: true,
    }, 'cet-sourcing-needs-v2');
  }

  /**
   * Called when user explicitly clicks "No" on an active requirement.
   * Deletes the sub-record if one exists, otherwise just clears the flag.
   */
  private deleteOrClearActiveTab(): void {
    const key = this.getRequirementKeyForActiveTab();
    const config = this.isRequiredModels.find((item) => item.key === key);
    if (!config) return;

    const hasSubRecord = this.hasMeaningfulData(config.data);
    if (hasSubRecord) {
      // Delegate to existing delete logic which handles sub-records correctly
      this.deleteActiveTab();
    } else {
      // No sub-record — just clear the flag and clean up OutsourcingEventRequest
      this.revertRequirementFlag(key);
    }
  }

  getRequirementValueForActiveTab(): boolean {
    const key = this.getRequirementKeyForActiveTab();
    const config = this.isRequiredModels.find((item) => item.key === key);
    return config ? config.value : false;
  }

  onDelete(): void {
    const activeTabName = this.getActiveTabName();
    const activeTabData = this.getDataForActiveTab();
    
    if (!activeTabData) {
      return;
    }

    this.deleteActiveTab();
  }

  private deleteActiveTab(): void {
    const key = this.getRequirementKeyForActiveTab();
    const config = this.isRequiredModels.find((item) => item.key === key);
    if (!config || !config.data) return;

    const deleteKeys = [
      'is_venue_required',
      'is_transport_required',
      'is_catering_required',
      'is_branding_collateral_required',
      'is_av_required',
      'is_photographer_videographer_required',
    ];

    const updateKeys: { [key: string]: any } = {
      is_experience_required: { experience_type: [] },
      is_furniture_required: { furniture_details: '' },
      is_speaker_on_stage_talent: { speaker_on_stage_talent: [] },
      is_gift_required: { gift_details: '', gift_rate: null },
      is_production_fabrication_required: {
        event_structures: [],
        infrastructure: [],
        live_streaming_hybrid: [],
        intercom_communication: []
      },
     };

    if (deleteKeys.includes(key)) {
      this.vm.deleteSorucingObject(config.data.id, key, () => {
        if (updateKeys[key]) {
          const payload = {
            ...this.getBasicPayload(),
            [key]: false,
            modified_by: this.loginModel.value.user.id,
            remove: false,
            ...updateKeys[key],
          };
          // console.log("======================if======================");
          this.vm.updateSourcingNeed(payload, 'cet-sourcing-needs-v2');
        }
      });
    } else if (updateKeys[key]) {
      const payload = {
        id: this.souringNeedId,
        modified_by: this.loginModel.value.user.id,
        remove: true,
        [key]: false,
        ...updateKeys[key],
      };
      this.vm.updateSourcingNeed(payload, 'cet-sourcing-needs-v2');
    }
  }

  private getRequirementKeyForActiveTab(): string {
    return this.getRequirementKey(this.activeTab);
  }

  private getBasicPayload(): any {
    return {
      id: this.souringNeedId,
      created_by: this.loginModel.value.user.id,
      event: this.eventId,
    };
  }

  isRequiredModels: RequiredItem[] = [
    {
      key: 'is_venue_required',
      data_key: 'venue_details',
      name: 'Venue',
      value: false,
      data: null,
      nzTitle: 'Venue',
      nzContent: SnFormVenueV2Component,
      colSpan: 1,
    },
    {
      key: 'is_experience_required',
      data_key: 'experience_type_details',
      name: 'Experience',
      value: false,
      data: null,
      nzTitle: 'Experience',
      nzContent: SnFormExperienceV2Component,
      colSpan: 1,
    },
    {
      key: 'is_furniture_required',
      data_key: 'furniture_details',
      name: 'Furniture',
      value: false,
      data: null,
      nzTitle: 'Furniture Requirements',
      nzContent: SnFormFurnitureV2Component,
      colSpan: 1,
    },
    {
      key: 'is_speaker_on_stage_talent',
      data_key: 'speaker_details',
      name: 'Talent',
      value: false,
      data: null,
      nzTitle: 'Talent',
      nzContent: SnFormSpeakerTalentV2Component,
      colSpan: 1,
    },
    {
      key: 'is_transport_required',
      data_key: 'transport_details',
      name: 'Transport Requirements',
      value: false,
      data: null,
      nzTitle: 'Transport Requirements',
      nzContent: SnFormTransportV2Component,
      colSpan: 1,
    },
    {
      key: 'is_gift_required',
      data_key: 'gift_details',
      name: 'Gifts & Merchandise',
      value: false,
      data: null,
      nzTitle: 'Gifts & Merchandise',
      nzContent: SnFormGiftV2Component,
      colSpan: 1,
    },
    {
      key: 'is_catering_required',
      data_key: 'catering_details',
      name: 'Catering',
      value: false,
      data: null,
      nzTitle: 'Catering',
      nzContent: SnFormCateringV2Component,
      colSpan: 1,
    },
    {
      key: 'is_photographer_videographer_required',
      data_key: 'sourcing_need_photo_video_details',
      name: 'Videographer & Photographer',
      value: false,
      data: null,
      nzTitle: 'Videographer/Photographer requirements',
      nzContent: SnFormPhotoVideoV2Component,
      colSpan: 1,
    },
    {
      key: 'is_branding_collateral_required',
      data_key: 'branding_collateral_details',
      name: 'Branding & Collateral',
      value: false,
      data: null,
      nzTitle: 'Branding & Collateral',
      nzContent: SnFormBrandingV2Component,
      colSpan: 2,
    },
    {
      key: 'is_av_required',
      data_key: 'av_requirements_details',
      name: 'AV Requirements',
      value: false,
      data: null,
      nzTitle: 'AV Requirements',
      nzContent: SnFormAvV2Component,
      colSpan: 3,
    },
    {
      key: 'is_production_fabrication_required',
      data_key: 'production_and_fabrication_details',
      name: 'Production & Fabrication',
      value: false,
      data: null,
      nzTitle: 'Production & Fabrication',
      nzContent: SnFormProductionFabricationV2Component,
      colSpan: 2,
    },
  ];

  activeTab: string = '';

  constructor(
    private vm: SourcingNeedV2ViewModel,
    private modalService: NzModalService,
    private cdr: ChangeDetectorRef,
    private message: NzMessageService
  ) {
    this.loginModel.next(AppCommon.getloggedInObject());
  }

  onRequirementToggle(required: boolean): void {
    const currentlyRequired = this.getRequirementValueForActiveTab();

    // Requirement can only be turned off via explicit Delete action.
    if (!required && currentlyRequired) {
      this.message.info(`Use Delete to remove ${this.getActiveTabName()} and set it to No.`, {
        nzDuration: 2000,
      });
      this.cdr.detectChanges();
      return;
    }

    this.onRequirementChange(required);
  }

  ngOnInit(): void {
    this.vm.parentCetSourcingNeedsV2Component = this;
    this.sourcingNeedModel = this.vm.sourcingNeedModel;
    this.sourcingNeedModel.subscribe((data) => {
      if (!data || !data.id) {
        return;
      }

      if (!this.isCurrentEventSourcingNeed(data)) {
        return;
      }

      this.sourcingNeedData = data;
      this.processReceivedData();
      this.populateMenuItems();
      this.updateViewEditState();
      this.cdr.detectChanges();
      this.updateViewEditState();
      this.cdr.detectChanges();
    });
    this.vm.outsourcingTypeResponseModel.subscribe((data) => {

      if(data?.results?.length > 0 && data !== null && data != undefined){
        this.outsourcingTypesList = []; // Clear existing list to avoid duplicates
        data?.results?.map((item)=>{
          this.outsourcingTypesList.push({
            id: item.id,
            name: item.name,
            image :item.image,
            description :item.description,  
            // is_active :item.is_active,
          })
        })
      }
      this.populateMenuItems(); // Update menu items when outsourcing types are loaded
      this.cdr.detectChanges();
      
    });
    this.vm.getOutSourcingTypes('', 1, 30);
    this.vm.getSouringEventTypes();
    if (this.souringNeedId) {
      this.vm.getSouringNeedbyId(this.souringNeedId, 'cet-sourcing-needs-v2');
    } else {
      this.initSourcingNeeds();
    }
  }

  private isCurrentEventSourcingNeed(data: any): boolean {
    if (!this.eventId) {
      return true;
    }
    const dataEventId = data?.event ?? data?.event_details?.id;
    return Number(dataEventId) === Number(this.eventId);
  }

  private resetSourcingNeedLocalState(): void {
    this.sourcingNeedData = null;
    this.venueData = null;
    this.cateringData = null;
    this.transportData = null;
    this.photoVideoData = null;
    this.brandingData = null;
    this.giftData = null;
    this.speakerData = null;
    this.furnitureData = null;
    this.experienceData = null;
    this.avData = null;
    this.productionFabricationData = null;

    this.isRequiredModels.forEach((item) => {
      item.value = false;
      item.data = null;
    });

    this.isView = false;
    this.isEdit = false;
    this.cdr.detectChanges();
  }

  // Callback methods for ViewModel
  sourcingNeedInitialized(): void {
    this.isSourcingNeedAvailable = true;
    this.cdr.detectChanges();
  }

  dataReceived(): void {
    this.cdr.detectChanges();
  }

  sourcingComponentDeleted(key: string): void {
    // if (this.souringNeedId) {
    //   this.vm.getSouringNeedbyId(this.souringNeedId, 'cet-sourcing-needs-v2');
    // }
     const payload = this.getBasicPayload();
    payload[key] = false;
    payload.remove = true;
    this.vm.updateSourcingNeed(payload, 'cet-sourcing-needs-v2');
  
  }

  initSourcingNeeds(): void {
    const payload = {
      created_by: this.loginModel.value.user.id,
      event: this.eventId,
    };
    // console.log('Initializing sourcing need with payload:', payload);
    this.vm.initSourcingNeed(payload);
  }

  populateMenuItems(): void {
    if (!this.sourcingNeedData) return;

    // Always show all menu items regardless of API flags
    // Always show all menu items regardless of API flags
    // const items = [
    //   { key: 'av', name: 'AV Requirements' },
    //   { key: 'photographer', name: 'Videographer & Photographer' },
    //   { key: 'catering', name: 'Catering' },
    //   { key: 'venue', name: 'Venue' },
    //   { key: 'branding', name: 'Branding & Collateral' },
    //   { key: 'gift', name: 'Gifts' },
    //   { key: 'transport', name: 'Transport Requirements' },
    //   { key: 'speaker', name: 'Speaker & Stage Talent' },
    //   { key: 'furniture', name: 'Furniture' },
    //   { key: 'experience', name: 'Experience' },
    // ];


    const items = [
        { key: 'overview', name: 'Overview' },
        { key: 'venue', name: 'Venue' },
        { key: 'experience', name: 'Experience' },
        { key: 'furniture', name: 'Furniture' },
        { key: 'speaker', name: 'Talent' },
        { key: 'transport', name: 'Transport Requirements' },
        { key: 'gift', name: 'Gifts & Merchandise' },
        { key: 'catering', name: 'Catering' },
        { key: 'photographer', name: 'Videographer & Photographer' },
        { key: 'branding', name: 'Branding & Collateral' },
        { key: 'av', name: 'AV Requirements' },
      { key: 'productionFabrication', name: 'Production & Fabrication' },
    ]

    this.menuItems = items.map(item => {
      const matchingType = this.findOutsourcingTypeByName(item.name);
        return {
            ...item,
            emoji: this.getEmoji(item.key),
            image: matchingType ? matchingType.image : undefined
        };
    });

    // Set the first menu item as active if not already set
    if (this.menuItems.length > 0 && !this.activeTab) {
      this.activeTab = this.menuItems[0].key;
    }
  }

  private getEmoji(shortKey: string): string {
    const shortToLongKeyMap: { [key: string]: string } = {
      'overview': 'overview',
      'venue': 'is_venue_required',
      'catering': 'is_catering_required',
      'photographer': 'is_photographer_videographer_required',
      'av': 'is_av_required',
      'branding': 'is_branding_collateral_required',
      'gift': 'is_gift_required',
      'transport': 'is_transport_required',
      'speaker': 'is_speaker_on_stage_talent',
      'furniture': 'is_furniture_required',
      'experience': 'is_experience_required',
      'productionFabrication': 'is_production_fabrication_required'
    };

    const emojiMap: { [key: string]: string } = {
      'overview': '📋',
      'is_venue_required': '🏛️',
      'is_experience_required': '🎉',
      'is_furniture_required': '🪑',
      'is_speaker_on_stage_talent': '🎤',
      'is_transport_required': '🚖',
      'is_gift_required': '🎁',
      'is_catering_required': '🍽️',
      'is_branding_collateral_required': '🏷️',
      'is_av_required': '🎧',
      'is_photographer_videographer_required': '🎥',
      'is_production_fabrication_required': '🏗️'
    };

    const longKey = shortToLongKeyMap[shortKey];
    return emojiMap[longKey] || '❓';
  }

  getItemStatus(key: string): boolean {
    // Overview always shows as available
    if (key === 'overview') return true;
    
    const requirementKey = this.getRequirementKey(key);
    const config = this.isRequiredModels.find((item) => item.key === requirementKey);    
    if (!config) return false;

    if (!config.value) return false;
    let hasData = false;
    if (config.data) {
        hasData = config.value;
    }
    
    return hasData;
  }

  private getRequirementKey(shortKey: string): string {
      const mapping: { [key: string]: string } = {
        'venue': 'is_venue_required',
        'catering': 'is_catering_required',
        'photographer': 'is_photographer_videographer_required',
        'av': 'is_av_required',
        'branding': 'is_branding_collateral_required',
        'gift': 'is_gift_required',
        'transport': 'is_transport_required',
        'speaker': 'is_speaker_on_stage_talent',
        'furniture': 'is_furniture_required',
        'experience': 'is_experience_required',
        'productionFabrication': 'is_production_fabrication_required'
      };
      return mapping[shortKey] || '';
  }

  processReceivedData(): void {
    if (!this.sourcingNeedData) return;

    // Assign _souringNeedId from sourcingNeedData.id if not set
    if (this.souringNeedId == null && this.sourcingNeedData.id != null) {
      this.souringNeedId = this.sourcingNeedData.id;
    }

    // Process venue data
    if (this.sourcingNeedData.is_venue_required && this.sourcingNeedData.venue_details) {
      this.venueData = this.sourcingNeedData.venue_details;
    } else {
      this.venueData = null;
    }

    // Process catering data
    if (this.sourcingNeedData.is_catering_required && this.sourcingNeedData.catering_details) {
      this.cateringData = this.sourcingNeedData.catering_details;
    } else {
      this.cateringData = null;
    }

    // Process transport data
    if (this.sourcingNeedData.is_transport_required && this.sourcingNeedData.transport_details) {
      this.transportData = this.sourcingNeedData.transport_details;
    } else {
      this.transportData = null;
    }

    // Process photo/video data
    if (this.sourcingNeedData.is_photographer_videographer_required && this.sourcingNeedData.sourcing_need_photo_video_details) {
      this.photoVideoData = this.sourcingNeedData.sourcing_need_photo_video_details;
    } else {
      this.photoVideoData = null;
    }

    // Process branding data
    if (this.sourcingNeedData.is_branding_collateral_required && this.sourcingNeedData.branding_collateral_details) {
      this.brandingData = this.withStageSizeDisplay(this.sourcingNeedData.branding_collateral_details);
    } else {
      this.brandingData = null;
    }

    // Process gift data
    if (this.sourcingNeedData.is_gift_required && (this.sourcingNeedData.gift_details || this.sourcingNeedData.gift_rate)) {
      this.giftData = {
        gift_details: this.sourcingNeedData.gift_details,
        gift_rate: this.sourcingNeedData.gift_rate
      };
    } else {
      this.giftData = null;
    }

    // Process speaker data
    if (this.sourcingNeedData.is_speaker_on_stage_talent && this.sourcingNeedData.speaker_details) {
      // Normalize before assigning
      this.speakerData = this.normalizeViewData(this.sourcingNeedData.speaker_details, 'speaker_details');
    } else {
      this.speakerData = null;
    }

    // Process furniture data
    if (this.sourcingNeedData.is_furniture_required && this.sourcingNeedData.furniture_details) {
      // Normalize before assigning
      this.furnitureData = this.normalizeViewData(this.sourcingNeedData.furniture_details, 'furniture_details');
    } else {
      this.furnitureData = null;
    }

    // Process experience data
    if (this.sourcingNeedData.is_experience_required && this.sourcingNeedData.experience_selection_details) {
      this.experienceData = this.sourcingNeedData.experience_selection_details[0] || null;
    } else {
      this.experienceData = null;
    }

    // Process AV data
    if (this.sourcingNeedData.is_av_required && this.sourcingNeedData.av_requirements_details) {
      this.avData = this.sourcingNeedData.av_requirements_details;
    } else {
      this.avData = null;
    }

    if (this.sourcingNeedData.is_production_fabrication_required && this.sourcingNeedData.production_and_fabrication_details) {
      this.productionFabricationData = this.sourcingNeedData.production_and_fabrication_details;
    } else {
      this.productionFabricationData = null;
    }

    // Also update the old structure for backward compatibility
    this.isRequiredModels.forEach(item => {
      item.value = this.sourcingNeedData?.[item.key] ?? false;
      if (item.value) {
        item.data = this.sourcingNeedData?.[item.data_key] ?? null;
      } else {
        item.data = null;
      }
    });
  }

  // Method to handle tab selection
  selectTab(key: string): void {
    this.activeTab = key;
    this.isEditingEventType = false;
    this.showEditEventTypeButton = true;    
    this.updateViewEditState();
    this.cdr.detectChanges();
  }

  // Get the name of the active tab
  getActiveTabName(): string {
    const activeItem = this.menuItems.find(
      (item) => item.key === this.activeTab
    );
    return activeItem ? activeItem.name : '';
  }

  // Method to validate and submit form data
  validateAndSubmit(): void {
    // This is now handled inside the modal components
  }

  getViewConfig(): any[] {
    switch (this.activeTab) {
      case 'av':
        return [
          { key: 'microphone_details', label: 'Microphones', type: 'array' },
          { key: 'speakers_audio_output_details', label: 'Speakers & Audio', type: 'array' },
          { key: 'audio_equipment_details', label: 'Audio Equipment', type: 'array' },
          { key: 'support_infra_details', label: 'Support Infra', type: 'array' },
          { key: 'av_staff_details', label: 'AV Staff', type: 'array' },
          { key: 'display_units_details', label: 'Display Systems', type: 'array' },
          { key: 'cameras_recording_details', label: 'Cameras & Recording', type: 'array' },
          { key: 'video_equipment_details', label: 'Video Equipment', type: 'array' },
          { key: 'general_stage_lighting_details', label: 'Stage Lighting', type: 'array' },
          { key: 'special_lighting_details', label: 'Ambient & Decorative Lighting', type: 'array' },
          { key: 'lighting_control_details', label: 'Lighting Control', type: 'array' },
          { key: 'rigging_support_details', label: 'Rigging Support', type: 'array' }
        ];
      case 'venue':
        return [
          // Legacy single venue/room type/seating style fields (kept for records created before
          // the multi-venue-room payload change). New records are shown via venue_rooms_details below.
          { key: 'venue_name', label: 'Venue', type: 'text', legacy: true },
          { key: 'room_type_name', label: 'Room Type', type: 'text', legacy: true },
          { key: 'seating_style_name', label: 'Seating Style', type: 'text', legacy: true },
          {
            key: 'venue_rooms_details', label: 'Venue, Room Type & Seating Style', type: 'group-array', fullWidth: true,
            groupFields: [
              { key: 'venue_name', label: 'Venue' },
              { key: 'room_type_name', label: 'Room Type' },
              { key: 'seating_style_name', label: 'Seating Style' }
            ]
          },
          { key: 'is_breakout_rooms_required', label: 'Breakout Rooms', type: 'boolean' },
          { key: 'number_of_breakout_rooms', label: 'No. of Breakout Rooms', type: 'text' }
        ];
      case 'catering':
        return [
          { key: 'catering_type_details', label: 'Catering Type', type: 'array' },
          { key: 'meal_type_details', label: 'Meal Type', type: 'array' },
          // API may provide 'meal_timing_details' (singular) instead of 'meal_timings_details'
          { key: 'meal_timing_details', label: 'Meal Timings', type: 'array' },
          { key: 'non_alcoholic_beverage_details', label: 'Non-Alcoholic Beverage', type: 'array' },
          { key: 'alcoholic_beverage_details', label: 'Alcoholic Beverage', type: 'array' },
          { key: 'dietary_preferences_details', label: 'Dietary Preferences', type: 'array' },
          { key: 'liquor_license_required', label: 'Liquor License', type: 'boolean' }
        ];
      case 'photographer':
        return [
          { key: 'video_description', label: 'No. of Videographers', type: 'text' },
          { key: 'photo_description', label: 'No. of Photographers', type: 'text' }
        ];
      case 'branding':
        return [
          { key: 'is_stage_required', label: 'Stage Required', type: 'boolean' },
          { key: 'stage_size_display', label: 'Stage Size', type: 'text', conditional: true },
          { key: 'stage_accessories_details', label: 'Stage & Stage Accessories', type: 'array' },
          { key: 'guest_management_details', label: 'Guest Management', type: 'array' },
          { key: 'signage_branding_details', label: 'Signage & Branding', type: 'array' },
          { key: 'demo_engagement_details', label: 'Demo & Engagement', type: 'array' },
          { key: 'media_advertising_details', label: 'Media Advertising', type: 'array' },
          { key: 'setup_branding_details', label: 'Setup & Branding', type: 'array' }
        ];
      case 'gift':
        return [
          { key: 'gift_details', label: 'Gifts & Merchandise Details', type: 'text' },
          { key: 'gift_rate', label: 'Budget (USD)', type: 'text' }
        ];
      case 'transport':
        return [
          { key: 'airport_transfers_details', label: 'Airport Transfers', type: 'array' },
          { key: 'local_venue_transfers_details', label: 'Local/Venue Transfers', type: 'array' },
          { key: 'vehicles_type_details', label: 'Vehicle Types', type: 'array' }
        ];
      case 'speaker':
      case 'speaker_on_stage_talent':
        return [
          { key: 'speaker_details', label: 'Speaker Details', type: 'array' }
        ];
      case 'furniture':
          return [
          { key: 'furniture_details', label: 'Furniture Details', type: 'text' }
        ];
      case 'experience':
        return [
          { key: 'experience_type_details.name', label: 'Experience Type', type: 'text' },
          { key: 'experience_category_details.name', label: 'Experience Category', type: 'text' },
          { key: 'experience_testing_type_details.name', label: 'Experience Testing Type', type: 'text', conditional: true }
        ];
      case 'productionFabrication':
        return [
          { key: 'event_structures_details', label: 'Event Structures', type: 'array' },
          { key: 'infrastructure_details', label: 'Infrastructure', type: 'array' },
          { key: 'live_streaming_hybrid_details', label: 'Live Streaming & Hybrid', type: 'array' },
          { key: 'intercom_communication_details', label: 'Intercom & Communication', type: 'array' }
        ];
      default:
        return [];
    }
  }

  private findOutsourcingTypeByName(name: string): any {
    const normalizedTarget = this.normalizeTypeName(name);
    return this.outsourcingTypesList.find((type) => this.normalizeTypeName(type?.name) === normalizedTarget);
  }

  private normalizeTypeName(name: string): string {
    return (name || '').toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
  }

  private withStageSizeDisplay(data: any): any {
    if (!data || typeof data !== 'object') {
      return data;
    }

    const stageRequired = !!data.is_stage_required;
    const width = Number(data.stage_dimension_x);
    const height = Number(data.stage_dimension_y);

    let stageSizeDisplay: string | null = null;
    if (stageRequired && Number.isFinite(width) && Number.isFinite(height)) {
      if (width === 8 && height === 8) {
        stageSizeDisplay = 'Small (8x8)';
      } else if (width === 12 && height === 8) {
        stageSizeDisplay = 'Medim (12x8)';
      } else if (width === 16 && height === 8) {
        stageSizeDisplay = 'Large (16x8)';
      } else {
        stageSizeDisplay = `Custom (${width}x${height})`;
      }
    }

    return {
      ...data,
      stage_size_display: stageSizeDisplay,
    };
  }

    /**
     * Ensures the data passed to CommonSourcingViewComponent matches the expected object structure.
     * If the data is a primitive (string, number, etc.), wraps it in an object with the given key.
     * If the data is already an object, returns as is.
     */
    normalizeViewData(data: any, key: string): any {
      if (data == null) return null;
      if (typeof data === 'object' && !Array.isArray(data)) return data;
      // For primitives, wrap in object
      return { [key]: data };
    }

}
